import React from "react";
import { useIntl } from "react-intl";
import { SwitchInput } from "@/component/input";

import { WebchatThemeFormProps } from ".";
import ChatQuickMenuInputGroup from "./ChatQuickMenuInputGroup";


const EtcInputGroup: React.FC<WebchatThemeFormProps> = (props) => {
    const { theme, onChange } = props;

    const intl = useIntl();

    return (
        <div className="flex flex-col gap-3">
            <div className="flex items-center">
                <label htmlFor="webchat-bottom-menu"
                       className="field-label-bold"
                >
                    {intl.formatMessage({ id: "i09090" })}
                </label>
                <SwitchInput id="webchat-bottom-menu"
                             className="ml-[108px]"
                             defaultValue={theme.bottomMenu?.enable}
                             onSwitch={value => {
                                 onChange({ ...theme, bottomMenu: { ...theme.bottomMenu, enable: value } });
                             }}
                />
            </div>
            <ChatQuickMenuInputGroup disabled={!theme.bottomMenu?.enable}
                                     legend={intl.formatMessage({ id: "i09090" })}
                                     quickMenu={theme.bottomMenu ?? {}}
                                     onChange={value => onChange({ ...theme, bottomMenu: value })}
            />
        </div>
    );
};

export default EtcInputGroup;
